import React from 'react';
import { Button, IconCancelOutlined } from '@gafe/common-ui';

import { Props } from './types';

import styles from './SideBarTextContent.module.scss';

export const SideBarTextContent = ({ handleClose, scrollToMessageBoard }: Props) => {
  return (
    <>
      <div className={styles.content_wrapper}>
        <div
          className={styles.closeIcon}
          data-testid="icon-close"
          onClick={handleClose}
          onKeyDown={handleClose}
          role="button"
        >
          <IconCancelOutlined />
        </div>
        <div className={styles.section_wrapper}>
          <p className={styles.title}>Lean Forward Benefits</p>
          <div>
            <span className={styles.subtitle}>100-Day Guarantee</span>
            <ul>
              <li>
                Roofing Partner and GAF Energy share a goal of achieving a project timeline of one
                100 days
              </li>
              <li>Homeowners will be compensated for delays over 100 days caused by GAF Energy</li>
              <li>
                The 100-day timeline is measured from “Order Submitted” to “Permission to Operate”
                (PTO)
              </li>
              <li>To remain eligible complete your tasks promptly</li>
            </ul>
            <span className={styles.subtitle}>Install with Roof Permit Only</span>
            <ul>
              <li>
                Install roof and solar shingles with just a roof permit, accelerating payment to you
              </li>
            </ul>
          </div>
        </div>
        <div className={styles.section_wrapper}>
          <p className={styles.title}>Status</p>
          <div>
            <div className={styles.content}>
              <div className={styles.title_wrapper}>
                <span className={styles.void_eligible}></span>
                <span className={styles.subtitle}>Under Review</span>
              </div>
              <span className={styles.content}>
                This project is running behind schedule and the homeowner may be eligible for
                compensation.
              </span>
            </div>
            <div className={styles.content}>
              <div className={styles.title_wrapper}>
                <span className={styles.void_circle}></span>
                <span className={styles.subtitle}>Void / Ineligible</span>
              </div>
              <span className={styles.content}>
                The project is no longer eligible for the 100-Day Guarantee.
              </span>
            </div>
            <div className={styles.content}>
              <div className={styles.title_wrapper}>
                <span className={styles.subtitle}>Questions?</span>
              </div>
              <span className={styles.content}>
                For complete Lean Forward program details, please contact your Project Coordinator
                via the
                <span
                  className={styles.highlight}
                  onClick={scrollToMessageBoard}
                  onKeyDown={scrollToMessageBoard}
                  role="button"
                >
                  Message Board
                </span>
              </span>
            </div>
          </div>
        </div>
      </div>
      <div className={styles.close_button}>
        <Button colorSchema="primary" onClick={handleClose} size="large" variant="text">
          CLOSE
        </Button>
      </div>
    </>
  );
};
